import { useNavigate } from 'react-router-dom';
import type { TournamentItem } from '../../items';
import { Container, Content, Header } from './styles';

interface CardProps {
  item: TournamentItem;
  position: number;
  foto: string;
}

export const Card: React.FC<CardProps> = ({ item, position, foto }: CardProps) => {
  const navigate = useNavigate();
  const enabled = item.disponivel && item.route !== null;

  return (
    <Container
      isDisabled={!enabled}
      {...(enabled && { onClick: () => navigate(item.route as string) })}
    >
      <Header>
        <p>{position}</p>
      </Header>

      <Content>
        <span>
          <img src={foto} alt={item.titulo} />
        </span>

        <div>
          <span>
            <h1>{item.titulo}</h1>
            <h2>{item.subtitulo}</h2>
          </span>
        </div>
      </Content>
    </Container>
  );
};
